export const CareplanPendingAction = {
  review: "review",
  approve: "approve",
} as const;
